"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectMicrophoneButton = exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _botframeworkWebchatCore = require("botframework-webchat-core");

var _Localize = require("../Localization/Localize");

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

var _MicrophoneIcon = _interopRequireDefault(require("./Assets/MicrophoneIcon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DictateState = _botframeworkWebchatCore.Constants.DictateState;
var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  '& > .sr-only': {
    color: 'transparent',
    height: 1,
    left: -10000,
    overflow: 'hidden',
    position: 'absolute',
    top: 'auto',
    width: 1
  }
});

var connectMicrophoneButton = function connectMicrophoneButton() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref) {
    var disabled = _ref.disabled,
        dictateState = _ref.dictateState,
        language = _ref.language,
        startDictate = _ref.startDictate,
        stopDictate = _ref.stopDictate;
    return {
      click: function click() {
        if (dictateState === DictateState.STARTING || dictateState === DictateState.DICTATING) {
          stopDictate();
        } else {
          startDictate();
        }
      },
      dictating: dictateState === DictateState.DICTATING,
      disabled: disabled || dictateState === DictateState.STARTING || dictateState === DictateState.STOPPING,
      language: language
    };
  }].concat(selectors));
};

exports.connectMicrophoneButton = connectMicrophoneButton;

var _default = connectMicrophoneButton(function (_ref2) {
  var styleSet = _ref2.styleSet;
  return {
    styleSet: styleSet
  };
})(function (_ref3) {
  var className = _ref3.className,
      click = _ref3.click,
      dictating = _ref3.dictating,
      disabled = _ref3.disabled,
      language = _ref3.language,
      styleSet = _ref3.styleSet;
  return _react.default.createElement("div", {
    "aria-controls": "webchatSendBoxMicrophoneButton",
    className: (0, _classnames.default)(styleSet.microphoneButton + '', ROOT_CSS + '', (className || '') + '', {
      dictating: dictating
    })
  }, _react.default.createElement(_IconButton.default, {
    alt: (0, _Localize.localize)('Speak', language),
    disabled: disabled,
    onClick: click
  }, _react.default.createElement(_MicrophoneIcon.default, null)), _react.default.createElement("div", {
    "aria-live": "polite",
    className: "sr-only",
    id: "webchatSendBoxMicrophoneButton",
    role: "status"
  }, (0, _Localize.localize)(dictating ? 'Microphone on' : 'Microphone off', language)));
});

exports.default = _default;